import { useEffect } from "react"
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useFetchStations } from "../hooks/StationHooks";
import { StationDTO } from "../types/stationDTO";
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import { useState } from "react";

const StationList = () => {
  const { t, i18n } = useTranslation();
  const nav = useNavigate();
  const { organisationId } = useParams<{ organisationId: string }>();
  if (!organisationId) throw new Error("Missing organisationId from params");
  const { data, isPending, isError } = useFetchStations(organisationId);
  const [sortField, setSortField] = useState<keyof StationDTO>('name');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const [searchTerm, setSearchTerm] = useState('');

  const handleSort = (field: keyof StationDTO) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortData = (data: StationDTO[]) => {
    return [...data].sort((a, b) => {
      if (sortField === 'name') {
        return sortDirection === 'asc'
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name);
      }

      if (sortField === 'validFrom' || sortField === 'validTo' || sortField === 'lastModified') {
        const aValue = new Date(a[sortField]).getTime();
        const bValue = new Date(b[sortField]).getTime();
        return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
      }

      return 0;
    });
  };

  const filteredData = data?.filter(station => 
    station.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

    useEffect(() => {
        if (isError) { nav('/login') }

    }, [isError]);

  if (isPending) return <Spinner animation="grow" />;

  return (
    <div>
      <div className="row mb-2 mt-2">
        <h5 className="subtitle text-left">
          {t('station.title')}
        </h5>
      </div>

      <div className="row mb-3">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder={t('common.search')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

        <table className="table table-hover table-striped"
            style={
                {
                    "--bs-table-hover-bg": "#C9DDED"
                } as React.CSSProperties
            }
        >
        <thead>
          <tr>
            <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
              {t('common.name')} {sortField === 'name' && (sortDirection === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('validFrom')} style={{ cursor: 'pointer' }}>
              {t('common.validFrom')} {sortField === 'validFrom' && (sortDirection === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('validTo')} style={{ cursor: 'pointer' }}>
              {t('common.validTo')} {sortField === 'validTo' && (sortDirection === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('lastModified')} style={{ cursor: 'pointer' }}>
              {t('common.lastModified')} {sortField === 'lastModified' && (sortDirection === 'asc' ? '▲' : '▼')}
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredData && sortData(filteredData).map((h: StationDTO) => {
            const dateOptions: Intl.DateTimeFormatOptions = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit'
            };

            return (
                <tr key={h.id} style={{ cursor: 'pointer' }} onClick={() => nav(`/organisation/${organisationId}/station/${h.id}`)}>
                <td>{h.name}</td>
                <td>{new Date(h.validFrom + 'Z').toLocaleString(i18n.language === 'fi' ? 'fi-FI' : 'en-US', dateOptions)}</td>
                <td>{new Date(h.validTo + 'Z').toLocaleString(i18n.language === 'fi' ? 'fi-FI' : 'en-US', dateOptions)}</td>
                <td>{new Date(h.lastModified + 'Z').toLocaleString(i18n.language === 'fi' ? 'fi-FI' : 'en-US', dateOptions)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Link className="btn btn-primary" to={`/organisation/${organisationId}/station/add`}>
        {t('station.add')}
      </Link>
    </div>
  );
};

export default StationList;
